import { Button, Grid, Typography } from '@mui/material';
import { mixed, object, string } from 'yup';
import React from 'react';
import { Form, Formik } from 'formik';
import InputForm from '../../../commun/input-form';
import { AddressGouvFeaturesPropertiesFormDto } from '../../../../services/dtos/form/address-gouv-features-properties-form.dto';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AutocompleteForm from '../../../commun/autocomplete-form';

/**
 * Composant la page étape une
 * @constructor
 */
export default function AddressMovingInForm(props: {
    handleSearchAddress: (event: object, value: string, reason: string) => void;
    handleChangeShowManualAddress: () => void;
    addresses: AddressGouvFeaturesPropertiesFormDto[];
    showManualAddress: boolean;
    validFormAddress: boolean;
    handleSumbitFormAddress: (values: any) => void;
}) {
    // Schéma de validation des données
    const validationSchema = object({
        //Validation du champ numero rue
        address: mixed<AddressGouvFeaturesPropertiesFormDto>().when(() =>
            props.showManualAddress
                ? mixed<AddressGouvFeaturesPropertiesFormDto>().notRequired()
                : mixed<AddressGouvFeaturesPropertiesFormDto>().required("L'adresse doit être renseignée")
        ),
        //Validation du champ numero rue
        numeroRue: string().when(() =>
            !props.showManualAddress
                ? string().trim().notRequired()
                : string().trim().required('Veuillez renseigner votre numéro de rue').matches(/^\d+$/, {
                      message: 'Seuls les caractères numériques sont autorisés',
                  })
        ),
        //Validation du champ rue
        rue: string().when(() =>
            !props.showManualAddress
                ? string().trim().notRequired()
                : string().trim().required('Veuillez renseigner votre nom de rue')
        ),
        //Validation du champ ville
        ville: string().when(() =>
            !props.showManualAddress
                ? string().trim().notRequired()
                : string().trim().required('Veuillez renseigner votre ville de résidence')
        ),
        //Validation du champ code postal
        codePostal: string().when(() =>
            !props.showManualAddress
                ? string().trim().notRequired()
                : string().trim().required('Veuillez renseigner votre code postal').matches(/^\d+$/, {
                      message: 'Seul les caractères numériques sont autorisés',
                  })
        ),
    });

    // Valeurs par défaut
    const iniValues = {
        address: '',
        numeroRue: '',
        rue: '',
        ville: '',
        codePostal: '',
        pays: { value: '', label: '' },
        complement: {
            batiment: '',
            etage: '',
            appartement: '',
            escalier: '',
            ville: '',
            numeroRue: '',
            rue: '',
        },
    };

    // Création de la page
    return (
        // Formulaire avec tableau pour afficher correctement les champs
        <Formik initialValues={iniValues} onSubmit={props.handleSumbitFormAddress} validationSchema={validationSchema}>
            <Form>
                {/*Autocomplete form*/}
                {/*Champ adresse qui va appeler l'api gouv*/}
                {/*Avec un autre composant qui permet d'afficher l'adresse manuellement si besoin*/}
                <AutocompleteForm
                    id="address"
                    name="address"
                    label="Adresse d'emménagement"
                    options={props.addresses}
                    handleInputChange={props.handleSearchAddress}
                    sx={{ marginTop: '20px' }}
                    attributValueName="label"
                    otherElement={
                        <Button
                            variant="text"
                            disableElevation
                            size="small"
                            onClick={props.handleChangeShowManualAddress}
                            endIcon={props.showManualAddress ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                        >
                            Adresse non trouvée ? cliquez ici pour renseigner votre adresse manuellement
                        </Button>
                    }
                />
                {/*On affiche l'adresse manuel si besoin*/}
                {props.showManualAddress && (
                    <>
                        {/*titre*/}
                        <Typography variant="h5" sx={{ marginTop: '10px' }}>
                            Adresse d'emménagement
                        </Typography>
                        {/*Début grid*/}
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={2}>
                                {/*Champ numero de rue*/}
                                <InputForm id="numeroRue" name="numeroRue" label={'N°'}></InputForm>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                {/*Champ complement numero de rue*/}
                                <InputForm
                                    id="complementnumeroRue"
                                    name="complement.numeroRue"
                                    label={'Bis, Ter, ...'}
                                ></InputForm>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                {/*Champ nom de rue*/}
                                <InputForm id="rue" name="rue" label={'Rue'}></InputForm>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                {/*Champ complément de rue*/}
                                <InputForm
                                    id="complementRue"
                                    name="complement.rue"
                                    label={'Complément de rue'}
                                ></InputForm>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {/*Champ entree ou residence...*/}
                                <InputForm
                                    id="batiment"
                                    name="complement.batiment"
                                    label={'Entrée, résidence...'}
                                ></InputForm>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {/*Champ étage*/}
                                <InputForm id="etage" name="complement.etage" label={'Etage'}></InputForm>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {/*Champ appartement*/}
                                <InputForm
                                    id="appartement"
                                    name="complement.appartement"
                                    label={'Appartement'}
                                ></InputForm>
                            </Grid>
                            {/*Champ complement d'adresse*/}
                            <Grid item xs={12} sm={6}>
                                <InputForm id="escalier" name="complement.escalier" label={'Escalier'}></InputForm>
                            </Grid>
                            {/*Champ code postal*/}
                            <Grid item xs={12} sm={4}>
                                <InputForm id="codePostal" name="codePostal" label={'Code postal'}></InputForm>
                            </Grid>
                            {/*Champ ville*/}
                            <Grid item xs={12} sm={4}>
                                <InputForm id="ville" name="ville" label={'Ville'}></InputForm>
                            </Grid>
                            {/*Champ complement ville*/}
                            <Grid item xs={12} sm={4}>
                                <InputForm
                                    id="complementville"
                                    name="complement.ville"
                                    label={'Complément ville'}
                                ></InputForm>
                            </Grid>
                        </Grid>
                    </>
                )}
                <Typography variant={'button'} sx={{ marginTop: '10px', display: 'flex', justifyContent: 'flex-end' }}>
                    {/*bouton valider*/}
                    <Button type="submit" variant="contained" disabled={props.validFormAddress}>
                        Rechercher
                    </Button>
                </Typography>
            </Form>
        </Formik>
    );
}
